import React, { Component } from "react";
import Topbar from "../Topbar/index";
import { connect } from "react-redux";
import SearchFormMobile from "components/SearchFormMobile"
import AlertMessage from "components/AlertMessage";

export class FullWidthApp extends Component {

  constructor() {
    super();
    this.state = {
    }
  }

  componentDidMount() {
  }

  getNavStyles = () => {
    switch (window.location.pathname) {
      default:
        return <Topbar page={this.props.page} />;
    }

  };

  render() {
    const { componentToRender } = this.props;

    return (
      <div>
        {this.getNavStyles()}

        <SearchFormMobile />

        {componentToRender}

        <AlertMessage />
      </div>
    )
  }
}

const mapStateToProps = () => ({});

export default connect(
  mapStateToProps,
  {
  }
)(FullWidthApp);

